import * as React from "react";

export const SectionHeader = ({ children }: { children: React.ReactNode }) => (
    <h1 className="theme-paragraph-color" style={{ marginTop: 16, fontSize: 12 }}>
        {children}
    </h1>
);


// WEBPACK FOOTER //
// ./src/components/loginManagement/components/SectionHeader.tsx